import { render, staticRenderFns } from "./InquiryStatusSelect.vue?vue&type=template&id=8bd5c270&"
import script from "./InquiryStatusSelect.vue?vue&type=script&lang=js&"
export * from "./InquiryStatusSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports